// extracted by mini-css-extract-plugin
export default {"dotsContainer":"Spinner_dotsContainer__9tiVf","dot":"Spinner_dot__zSd+y","pulse":"Spinner_pulse__Q59Oc"};